import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import * as fromFollows from '@core/reducers/follow.reducer';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { NgProgress, NgProgressRef } from '@ngx-progressbar/core';
import * as FollowActionTypes from '../../actions/follow.actions';

@Component({
  selector: 'app-modal-query-filter',
  templateUrl: './modal-query-filter.component.html',
  styleUrls: ['./modal-query-filter.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ModalQueryFilter implements OnInit {
  constructor(
    private ngProgress: NgProgress,
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private store: Store<any>,
  ) { }

  @Input()
  followYears;

  newFollowYearsSelector = []

  progressRef: NgProgressRef
  queryForm;
  yearsSelected = []
  n5Selected = []
  follows$ = this.store.pipe(select(fromFollows.getFollowsYears));

  years = [
    2021,
    2022,
    2023,
    2024,
    2025
  ]

  n5 = [
    'AMBIENTE',
    'CONSUMO MASIVO',
    'ELECTRO',
    'FERRETERIA',
    'HARD',
    'HOGAR',
    'JARDIN Y MASCOTAS',
    'JUGUETERÍA',
    'OUTDOOR',
    'PERECIBLES',
    'SOFT',
    'VESTUARIO',
  ]

  ngOnInit() {
    this.progressRef = this.ngProgress.ref();
    this.store.dispatch(new FollowActionTypes.GetFollowYears())
    const newForm = {}
    this.queryForm = this.fb.group(newForm)
  }

  close(){
    this.activeModal.close()
  }

  save(){
    this.activeModal.dismiss({ 
      yearsSelected: this.yearsSelected,
      n5Selected: this.n5Selected 
    })
  }

  changeSelected(e, type){
    if(type === 'year'){
      if(!this.yearsSelected.map((y) => y).includes(e.target.value)){
        this.yearsSelected.push(e.target.value)
      }
    }else{
      if(!this.n5Selected.map((y) => y).includes(e.target.value)){
        this.n5Selected.push(e.target.value)
      }
    }
  }

  deleteSelected(e, type){
    if(type === 'year'){
      this.yearsSelected = this.yearsSelected.filter((y) => y !== e)
    } else{
      this.n5Selected = this.n5Selected.filter((n) => n !== e)
    }
  }
  
}